<template>
<div class="bijia-privacy-page">


    <!-- 隐私政策内容 -->
    <div class="section privacy-content-section">
        <div class="container">
            <el-card shadow="hover" class="privacy-card">
                <!-- 引言 -->
                <div class="privacy-section">
                    <!-- <h2 class="section-title">隐私政策</h2> -->
                    <div v-html="content"></div>
                </div>
                
            </el-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    getPrivacyApi
} from '@/api/index'

export default {
    name: 'WhyPrivacyPage',
    data() {
        return {
            activeRights: ['1'],
            content: '',
        }
    },
    mounted() {
        this.getPrivacy()
    },
    methods: {
        //获取-隐私政策
        getPrivacy() {
            try {
                let that = this
                getPrivacyApi().then(res => {
                    console.log('getPrivacyApi...', res)
                    that.content = res.content
                })
                // 处理数据...
            } catch (error) {
                console.error('获取数据失败:', error)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.bijia-privacy-page {
    padding-top: 80px;

    .privacy-banner {
        height: 400px;
        background-image: url('@/assets/images/privacy-banner.jpg');
        background-size: cover;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
        }

        .banner-content {
            position: relative;
            z-index: 1;

            h1 {
                font-size: 48px;
                margin: 0 0 15px;
            }

            p {
                font-size: 24px;
                margin: 0;
            }
        }
    }

    .section {
        padding: 60px 0;

        &.privacy-content-section {
            background-color: #f9f9f9;
        }
    }

    .container {
        max-width: 1000px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .privacy-card {
        border-radius: 12px;
        border: none;

        /deep/ .el-card__body {
            padding: 50px;
        }
    }

    .privacy-section {
        margin-bottom: 40px;

        .section-title {
            color: #333;
            font-size: 22px;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
            display: flex;
            align-items: center;

            i {
                margin-right: 10px;
                color: #ff6b81;
            }
        }

        p {
            color: #555;
            line-height: 1.8;
            margin-bottom: 15px;
        }
    }

    .privacy-list {
        padding-left: 20px;
        color: #555;

        li {
            margin-bottom: 10px;
            line-height: 1.6;
        }
    }

    .usage-steps {
        margin: 20px 0;

        /deep/ .el-step__title {
            font-size: 16px;
            color: #333;
        }

        /deep/ .el-step__description {
            font-size: 14px;
            color: #666;
        }
    }

    .protection-items {
        margin-top: 30px;

        .protection-item {
            background: #fff;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
            height: 100%;

            i {
                font-size: 30px;
                color: #ff6b81;
                margin-bottom: 15px;
                display: block;
            }

            h3 {
                margin: 0 0 10px;
                color: #333;
            }

            p {
                margin: 0;
                color: #666;
                font-size: 14px;
            }
        }
    }

    .rights-collapse {
        margin-top: 20px;
        border: none;

        /deep/ .el-collapse-item__header {
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            padding-left: 10px;
            border-bottom: 1px solid #eee;
        }

        /deep/ .el-collapse-item__content {
            padding: 15px;
            color: #666;
        }
    }

    .contact-section {
        .contact-methods {
            background: #f5f5f5;
            padding: 20px;
            border-radius: 8px;
            margin-top: 20px;

            p {
                margin: 0 0 10px;
                display: flex;
                align-items: center;

                i {
                    margin-right: 10px;
                    color: #ff6b81;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .update-date {
        text-align: right;
        color: #999;
        font-size: 14px;
        margin-top: 40px;
    }

    @media (max-width: 768px) {
        .privacy-banner {
            height: 300px;

            h1 {
                font-size: 36px;
            }

            p {
                font-size: 18px;
            }
        }

        .privacy-card /deep/ .el-card__body {
            padding: 30px 20px;
        }

        .protection-item {
            padding: 15px !important;
        }
    }
}
</style>
